module.exports = __webpack_public_path__ + "static/media/down_arrows_left.1fbc6619.png";